/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
import UnifiedDayHeader from './UnifiedDayHeader';

const SubHeader = () => (
  <UnifiedDayHeader
    viewType='dayView'
    showWorkoutName
  />
);

export default SubHeader;
